import React, { useState, useEffect } from 'react';
import theme from './BuyerChangeRequestView.module.scss';
import { Trans } from '@lingui/react/macro';
import { Modal, ModalHeader, ModalBody } from '@ygtechnologies/bygr-frontend-component-library';
import { BuyerChangeRequestStatus, ChangeRequestProgressInfo } from '@/types';
import ChangeRequestAttachmentList from '@/seller/components/change-requests/ChangeRequestAttachmentList';
import { Button } from '@/components/Buttons';
import { addAttachmentToChangeRequest } from '@/services/buyer-dashboard';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';

type Props = {
    isOpen: boolean;
    handleCloseClick: () => void;
    changeRequest: ChangeRequestProgressInfo;
};

const BuyerChangeRequestView: React.FC<Props> = ({ isOpen, handleCloseClick, changeRequest }) => {
    const [staticAttachments, setStaticAttachments] = useState(changeRequest.attachments);
    const permissions = useSelector((state: IState) => state.buyer.permissions!);

    useEffect(() => {
        setStaticAttachments(changeRequest.attachments);
    }, [changeRequest]);

    const canAdd = permissions.canModify && changeRequest.status === BuyerChangeRequestStatus.RequestSent;
    return (
        <Modal size="lg" isOpen={isOpen} toggle={handleCloseClick}>
            <ModalHeader>
                <Trans>Change request details #{changeRequest.changeRequestId}</Trans>
            </ModalHeader>
            <ModalBody className={theme.container}>
                <h5>{changeRequest.subject}</h5>
                <p>{changeRequest.description}</p>

                {canAdd && (
                    <i className={theme.hintText}>
                        <Trans>You can add more attachments to the request.</Trans>
                    </i>
                )}

                <ChangeRequestAttachmentList
                    canEdit={false}
                    useUploadWizard
                    canAdd={canAdd}
                    onChange={async (attachments) => {
                        var newAttachments = await addAttachmentToChangeRequest(
                            permissions.residentialUnitId,
                            changeRequest.changeRequestId,
                            attachments.filter((a) => !a.id)
                        );
                        setStaticAttachments(staticAttachments.concat(newAttachments));
                    }}
                    value={staticAttachments}
                />
                <Button onClick={handleCloseClick} color={'secondary'}>
                    <Trans>Close</Trans>
                </Button>
            </ModalBody>
        </Modal>
    );
};

export default BuyerChangeRequestView;
